import { render, staticRenderFns } from "./DateSelect.vue?vue&type=template&id=4c870ecd&scoped=true&"
import script from "./DateSelect.vue?vue&type=script&lang=js&"
export * from "./DateSelect.vue?vue&type=script&lang=js&"
import style0 from "./DateSelect.vue?vue&type=style&index=0&id=4c870ecd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c870ecd",
  null
  
)

export default component.exports